import { Card, Stack } from "@mantine/core";
import { IStatbox } from "@mctypes/frontend.types";
import { IIssueSumHours } from "@schemas/issueSchema";
import React from "react";
import { StatsBox } from "../../app/routes/issuesApp/StatsBox";

const TimeSum: React.FC<{ sumHours: IIssueSumHours }> = ({ sumHours }) => {
  const statsboxes: IStatbox[] = [
    {
      icon: "fa-clock-o",
      value: sumHours?.totalOrignalEstimate || 0,
      text: "Timer estimert",
      classColor: "text-succss",
    },
    {
      icon: "fa-clock-o",
      value: sumHours?.totalCompleted || 0,
      text: "Brukte timer",
      classColor: "text-succss",
    },
    {
      icon: "fa-clock-o",
      value: sumHours?.totalRemaining || 0,
      text: "Gjenstående timer",
      classColor: "text-succss",
    },
  ];

  return (
    <Card withBorder radius="md" shadow="xs" p="md">
      <Stack gap="md">
        {statsboxes.map((stat, index) => (
          <StatsBox key={index} stat={stat} />
        ))}
      </Stack>
    </Card>
  );
};

export default TimeSum;
